module.exports = __webpack_public_path__ + "img/pos2_banner.d6a12af8.png";